<template lang="pug">
.refund-bonus-preview
  .bonus-item-row.bonus-item-row--readonly(:class="rowClass")
    .bonus-item-check
      .bonus-checkbox.bonus-checkbox--checked
        .bonus-check-icon
    .bonus-item-info
      .bonus-item-code {{ bonusCode }}
      .bonus-item-fraction {{ amountLine }}
      .bonus-item-status-line {{ statusDisplay }}
</template>

<script>
import mFilters from '@/mixins/filters'

export default {
  name: 'RefundBonusPreviewRow',

  mixins: [mFilters],

  props: {
    bonusCode: {
      type: String,
      required: true
    },
    originalValue: {
      type: Number,
      required: true
    },
    remainingValue: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      default: 'created'
    }
  },

  computed: {
    amountLine () {
      if (this.remainingValue === this.originalValue) {
        return this.money(this.remainingValue)
      }
      return `${this.money(this.remainingValue)} de ${this.money(this.originalValue)}`
    },
    rowClass () {
      return {
        'bonus-item-row--pending': this.status === 'created',
        'bonus-item-row--approved': this.status === 'approved'
      }
    },
    statusDisplay () {
      if (this.status === 'created') return 'Pendiente de aprobación'
      if (this.status === 'approved') return 'Aprobado'
      return this.status || ''
    }
  }
}
</script>

<style lang="stylus" scoped>
.refund-bonus-preview
  margin 1rem 0 0

.bonus-item-row--readonly
  cursor default
  pointer-events none

  &:hover
    border-color inherit

.bonus-item-row
  display flex
  gap 1rem
  align-items flex-start
  padding 1.1rem 1rem
  border 1px solid rgba(0, 0, 0, 0.09)

.bonus-item-row--pending
  background rgba(200, 150, 0, .08)
  border 1px solid rgba(200, 150, 0, .28)

.bonus-item-row--approved
  background rgba(81, 165, 64, .1)
  border 1px solid rgba(81, 165, 64, .28)

.bonus-item-check
  padding-top .2rem
  flex-shrink 0

.bonus-checkbox
  width 1.5rem
  height 1.5rem
  border 2px solid rgba(0, 0, 0, 0.4)
  display flex
  align-items center
  justify-content center
  flex-shrink 0

.bonus-checkbox--checked
  background-color #000
  border-color #000

.bonus-check-icon
  width .55rem
  height .85rem
  border-right 2px solid #fff
  border-bottom 2px solid #fff
  transform rotate(45deg)
  margin-top -.1rem

.bonus-item-info
  flex 1
  display flex
  flex-direction column
  gap .35rem
  font-size 1.05em
  min-width 0

.bonus-item-code
  font-size .82em
  font-weight 700
  letter-spacing .02em
  text-transform uppercase
  opacity .9

.bonus-item-fraction
  font-size 1em
  font-weight 600
  line-height 1.35

.bonus-item-status-line
  font-size .88em
  line-height 1.35
  font-weight 500

.bonus-item-row--pending .bonus-item-status-line
  color #7a6200

.bonus-item-row--approved .bonus-item-status-line
  color #3d7a34
</style>



// WEBPACK FOOTER //
// src/components/pages/order/refund/RefundBonusPreviewRow.vue